<template lang="pug">

  span(ref="text")

    slot

</template>

<script>

export default {
  props: {
    maxLines: {
      default: 2,
      type: Number
    }
  },
  data () {
    return {
      fontSize: null,
      lineHeight: null
    }
  },
  mounted () {
    const style = window.getComputedStyle(this.$refs.text, null)
    this.fontSize = parseFloat(style.getPropertyValue('font-size'))
    this.lineHeight = parseFloat(style.getPropertyValue('line-height'))
    if (isNaN(this.lineHeight)) this.lineHeight = this.fontSize

    this.$el.addEventListener('resize', this.autoResize)
    this.autoResize()
  },
  beforeDestroy () {
    this.$el.removeEventListener('resize', this.autoResize)
  },
  methods: {
    autoResize () {
      let divHeight, lines

      let fs = this.fontSize
      let lh = this.lineHeight

      do {
        fs--
        lh--
        lh = Math.max(fs, lh)
        this.$refs.text.style.fontSize = fs + 'px'
        this.$refs.text.style.lineHeight = lh + 'px'

        divHeight = this.$refs.text.offsetHeight
        lines = divHeight / lh
      } while (lines > this.maxLines)
    }
  }
}
</script>
